import React, { useState, useEffect, useContext } from "react";
import AximDropdown from "components/Dropdown/AximDropdown";
import { Box } from "@mui/material";
import { apiGet } from "app/Services/ApiService";
import { employeeApiUrls } from "common/ApiUrls";
import LoaderAnimation from "pages/LoaderAnimation";
import TableAllData from "components/Content/CustomTable/TableAllData";
import TableStyle from "components/Content/Table/TableStyle.module.css";

import { Utils } from "common/Utils";
import moment from "moment";

export default function Hourbank () {
    const [hourbankTypeDropdown, setHourbankTypeDropdown] = useState([]);
    const [hourbankYearDropdown, setHourbankYearDropdown] = useState([]);
    const [hourbankTypeSelected, setHourbankTypeSelected] = useState(null);
    const [hourbankYearSelected, setHourbankYearSelected] = useState(null);

    const [payDatesDropdown, setPayDatesDropdown] = useState([]);
    const [payDateSelected, setPayDateSelected] = useState("");
    const [hourbanks, setHourbanks] = useState([]);
    const [hourbankTypes, setHourbankTypes] = useState(null);
    const [hasInitializationError, setHasInitializationError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        apiGet(employeeApiUrls.getHourbankTypes).then((response) => {
            setHourbankTypes(response.data)
            setHourbankTypeDropdown(response.data.map(hb => hb.hourbankTypeCode).filter(Utils.onlyUnique))
            setHourbankYearDropdown(response.data.map(hb => hb.hwBenefitDate).filter(Utils.onlyUnique))

            if (response.data.length > 0) {
                let firstHourType = response.data[0];
                setHourbankTypeSelected(firstHourType.hourbankTypeCode)
                setHourbankYearSelected(firstHourType.hwBenefitDate)
                loadHourbankData(firstHourType.hourbankTypeCode, firstHourType.hwBenefitDate)

            }
            else {
                //no hourbank available
            }
        })
            .catch(e => {
                console.log(e);
                setHasInitializationError(true);
            });

    }, [])
    const loadHourbankData = (hourbankType, hourbankYear) => {
        apiGet(employeeApiUrls.getHourbankBalance(hourbankType, hourbankYear + '-01-01')).then((balanceResponse) => {
            console.log(balanceResponse.data, 'hourbank balance');
            let beggingBalance = balanceResponse.data
            apiGet(employeeApiUrls.getHourbanks(hourbankType, hourbankYear + '-01-01', hourbankYear + '-12-31')).then((hourbanksResponse) => {
                console.log(hourbanksResponse.data, ' hourbank data');
                for (let i = 0; i < hourbanksResponse.data.length; i++) {
                    hourbanksResponse.data[i].beginningBalance = beggingBalance
                    hourbanksResponse.data[i].endingBalance = beggingBalance + hourbanksResponse.data[i].amount + hourbanksResponse.data[i].retroAmount
                    beggingBalance = hourbanksResponse.data[i].endingBalance
                }
                setHourbanks(hourbanksResponse.data)
                setIsLoading(false)
            })
            .catch(e => {
                console.log(e);
                setHasInitializationError(true);
            });
        })
        .catch(e => {
            console.log(e);
            setHasInitializationError(true);
        });
    }

    const columns = [
        {
            Header: "Date",
            accessor: "periodName",
            accessor: (cell) => moment(cell.periodName).format("yyyy-MM-DD"),
        },
        {
            Header: "Beginning Balance",
            accessor: "beginningBalance",
            accessor: (cell) => Utils.formatCurrency(cell.beginningBalance),
            canFilter: false
        },
        {
            Header: "Contribution Amount",
            accessor: (cell) => Utils.formatCurrency(cell.amount),
            canFilter: false
        },
        {
            Header: "Retro Amount This Year",
            accessor: (cell) => Utils.formatCurrency(cell.retroAmountInYear),
        },
        {
            Header: "Retro Amount Prior Year",
            accessor: (cell) => Utils.formatCurrency((cell.retroAmount - cell.retroAmountInYear)),
        },
        {
            Header: "Total Retro Amount",
            accessor: (cell) => Utils.formatCurrency(cell.retroAmount),
        },
        {
            Header: "Ending Balance",
            accessor: (cell) => Utils.formatCurrency(cell.endingBalance),
        }
    ];

    return (
        <Box className={TableStyle.tableWrapper}>
            <Box className="d-flex justify-content-start">
                {hourbankTypes === null ? <LoaderAnimation /> :
                    hourbankTypes.length > 0 ? (
                        <>
                            <AximDropdown
                                label="Hourbank Type"
                                handleChange={(e) => {
                                    setHourbankTypeSelected(e.target.value)
                                    loadHourbankData(e.target.value, hourbankYearSelected)
                                }}
                                value={hourbankTypeSelected}
                                pairs={hourbankTypeDropdown.map(ht => ({ value: ht, text: ht }))} />

                            <AximDropdown
                                label="Year"
                                handleChange={(e) => {
                                    setHourbankYearSelected(e.target.value)   
                                    loadHourbankData(hourbankTypeSelected, e.target.value)
                                }}
                                value={hourbankYearSelected}
                                pairs={hourbankYearDropdown.map(ht => ({ value: ht, text: ht }))} />
                        </>
                    ) : (
                        ""
                    )}
            </Box>
            <Box>
                {hasInitializationError ? <h4>Error Loading Hourbank</h4> :
                    hourbanks === null ? <LoaderAnimation /> :
                        hourbanks.length === 0 ? <h5 className="text-center mb-4">No hourbank to display</h5> :
                            <Box className="container-fluid">
                                <Box className="row justify-content-center">
                                    <TableAllData columns={columns} data={hourbanks} isLoading={isLoading} hidePagination={true}/>
                                </Box>
                            </Box>
                }
            </Box>
        </Box>
    )
}
